import { persistedState } from 'svelte-persisted-state';

// RoastLog
import { createRoastingEvent, deleteRoastingEvent, updateRoastingEvent } from '$lib/api';
import type { RoastingEvent } from '$lib/types/RoastLog';

class RoastingEvents {
  events = persistedState<RoastingEvent[]>('roastingEvents', []);

  constructor() {}

  get items() {
    return this.events.current;
  }

  set items(events: RoastingEvent[]) {
    this.events.current = events;
  }

  get length(): number {
    return this.events.current.length;
  }

  append(item: RoastingEvent) {
    this.events.current.push(item);
  }

  at(index: number): RoastingEvent {
    return this.events.current[index];
  }

  clear() {
    this.events.reset();
  }

  async createNewEventAt(index: number, event: RoastingEvent) {
    console.assert(event.id === undefined);
    console.assert(event.name !== undefined);

    // New event from the API
    const newEvent = await createRoastingEvent(event);

    // Replace the item at the given index
    this.events.current.splice(index, 1, newEvent);
    return newEvent;
  }

  /**
   * Delete an item for a specific id. Note that new events can have an undefined value for id.
   * @param itemId event id
   */
  deleteItemById(itemId: number) {
    this.events.current = this.events.current.filter((item) => item.id !== itemId);
  }

  /**
   * Delete an item at a specific index
   * @param index Numeric index to delete
   */
  deleteItemByIndex(index: number) {
    const deletedEvent = this.events.current.splice(index, 1)[0];
    if (deletedEvent?.id) {
      deleteRoastingEvent(deletedEvent.id);
    }
    return deletedEvent;
  }

  isNewEvent(event: RoastingEvent): boolean {
    return event.id === undefined;
  }

  async updateEventAt(index: number, event: RoastingEvent) {
    const updatedEvent = await updateRoastingEvent(event);
    this.events.current[index] = updatedEvent;
  }
}

export const roastingEvents = new RoastingEvents();
